var map = {
	"./Daimler.json": "ycpy",
	"./Einnahmequellen.json": "sRMI",
	"./Gilette.json": "Tk7O",
	"./Kanäle.json": "Tg4p",
	"./Kostenstruktur.json": "6E3z",
	"./Kundenbeziehungen.json": "oNEm",
	"./Kundensegment.json": "LZ1n",
	"./Nespresso.json": "i9hu",
	"./Online-Zeitung.json": "C+x1",
	"./Schlüsselaktivitäten.json": "Hz16",
	"./Schlüsselpartner.json": "DO1Q",
	"./Schlüsselressourcen.json": "mn8A",
	"./Skype.json": "1aqM",
	"./Wertangebot.json": "ecH/",
	"./bmas.json": "SC1t",
	"./data.json": "1mYX",
	"./flare.json": "tXcK",
	"./kirc.json": "mSWu",
	"./pdflogo.json": "TKmp",
	"./technologies.json": "ixOT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ojeH";


//////////////////
// WEBPACK FOOTER
// ./static ^\.\/.*\.json$
// module id = ojeH
// module chunks = 1